module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/mainvisual-title-sp_092ad406b2c3f427655c89f16c88cae8.png";